import { AritoDialog, AritoForm, AritoIcon, BottomBar } from '@/components/custom/erp';
import { SaveTemplateSchema } from '../schema';
import { BasicInfo } from './BasicInfo';

interface SaveTemplateDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  mode: 'add' | 'edit' | 'view';
  initialData?: any;
}

const SaveTemplateDialog: React.FC<SaveTemplateDialogProps> = ({ open, onClose, onSave, mode, initialData }) => {
  const title = mode === 'add' ? 'Lưu mẫu báo cáo' : 'Sửa mẫu báo cáo';
  const onSubmit = (data: any) => {
    onSave(data);
  };

  return (
    <AritoDialog
      open={open}
      onClose={onClose}
      title={title}
      titleIcon={<AritoIcon icon={12} />}
      maxWidth='lg'
      zIndex={100}
    >
      <div onSubmit={e => e.stopPropagation()} className='h-44 max-h-[80vh] min-w-[900px] bg-gray-50'>
        <AritoForm
          mode={mode}
          initialData={initialData}
          onSubmit={onSubmit}
          schema={SaveTemplateSchema}
          hasAritoActionBar={false}
          tabs={<BasicInfo />}
          bottomBar={<BottomBar onClose={onClose} mode={mode} />}
        />
      </div>
    </AritoDialog>
  );
};

export default SaveTemplateDialog;
